import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import AjaxLoader from '../../../../../ajax/components/AjaxLoader';
import styles from '../../waitMusic/waitMusic.module.scss';
import { BrowserTab } from './Browse';
import UploadTab from './Upload';
export default class HoldMusicWithPlayer extends Component {
    constructor(props) {
        super(props);
        this.audioHideModalHandler = () => {
            this.props.audioHideModal();
        };
        this.state = {
            showUploadTab: false,
        };
    }
    componentDidMount() {
        this.props.holdMusicGetAll().then((response) => {
            if (response.data && response.data.wait_music) {
                for (const music of response.data.wait_music) {
                    if (music.uuid === this.props.organization.default_hold_music_id) {
                        const currentMusic = Object.assign({}, music, { id: music.uuid });
                        this.props.holdMusicSelect({ selectedAudio: currentMusic });
                    }
                }
            }
        });
    }
    componentWillUnmount() {
        this.props.audioReset();
    }
    render() {
        let tryAgainBtn = null;
        if (this.props.meta.getAsyncStatus === 'failed') {
            tryAgainBtn = (_jsx("div", Object.assign({ className: "text-center" }, { children: _jsx(Button, Object.assign({ variant: "danger", onClick: () => {
                        this.props.holdMusicGetAll();
                    } }, { children: "Error on fetch audio - try again" })) })));
        }
        return (_jsxs("div", Object.assign({ className: styles.audioHolder }, { children: [_jsxs("div", Object.assign({ className: styles.sectionHeader }, { children: [_jsx("h5", { children: "Audio File" }), this.state.showUploadTab ? (_jsx(Button, Object.assign({ type: "button", variant: "tertiary", onClick: () => this.setState({ showUploadTab: false }) }, { children: "-Hide uploader" }))) : (_jsx(Button, Object.assign({ type: "button", variant: "tertiary", onClick: () => this.setState({ showUploadTab: true }) }, { children: "+Add new" })))] })), _jsxs("div", Object.assign({ className: styles.browseAudio }, { children: [tryAgainBtn, _jsx(BrowserTab, Object.assign({ waitMusicSelect: this.props.holdMusicSelect }, this.props)), this.state.showUploadTab && (_jsx("div", { children: 
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            _jsx(UploadTab, { meta: this.props.meta, selectedAudio: this.props.selectedAudio, waitMusicUpload: this.props.holdMusicUpload, waitMusicSplit: this.props.holdMusicSplit, waitMusicWaitingForSplitingOpen: this.props.holdMusicHoldingForSplitingOpen, waitMusicWaitingForSplitingClose: this.props.holdMusicHoldingForSplitingOpen }) })), _jsxs(Modal, Object.assign({ className: styles.waitingForSpilitingModal, isOpen: this.props.isHoldingOpen, onClose: this.props.holdMusicHoldingForSplitingClose }, { children: [_jsx(ModalHead, { title: "Almost done", onClose: this.props.holdMusicHoldingForSplitingClose }), _jsx(ModalBody, { children: _jsxs("div", { children: [_jsx("h3", Object.assign({ style: { textAlign: 'center' } }, { children: "Please wait while preparing your audio file." })), _jsx("p", { children: this.props.jobIds.length > 0 &&
                                                    `${this.props.jobIds.length} is waiting to be completed...` }), _jsx(AjaxLoader, {})] }) })] }))] }))] })));
    }
}
